<div class="campaign-card-footer">
  <div class="cc-social">
    <button type="button" class="cc-social-btn" [class.liked]="isLiked()" (click)="togglikes($event)"
      title="Gostar da campanha">
      <i class="fas fa-heart text-red-500" *ngIf="isLiked()"></i>
      <i class="far fa-heart" *ngIf="!isLiked()"></i>
      <span>{{ totalCurtidas || 0 }}</span>
    </button>

    <button type="button" class="cc-social-btn" [class.active]="showComment" (click)="commentCampanha($event)"
      title="Comentar campanha">
      <i class="far fa-comment"></i>
      <span>{{ totalComentarios || 0 }}</span>
    </button>

    <button type="button" class="cc-social-btn" (click)="shareCard($event)" title="Partilhar campanha">
      <i class="fas fa-share-nodes"></i>
    </button>
  </div>

  <!-- Floating Comment Card -->
  <div class="floating-comment-card" *ngIf="showComment" (click)="$event.stopPropagation()">
    <div class="floating-comment-header">
      <div class="header-info">
        <i class="pi pi-comment text-primary"></i>
        <span>Escrever Comentário</span>
      </div>
      <button type="button" class="btn-close" (click)="closeComment($event)" title="Fechar"
        aria-label="Fechar comentário">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <form [formGroup]="formComment" (ngSubmit)="submitComment()">
      <div class="floating-comment-body">
        <div class="avatar-col">
          <p-avatar [label]="initials || 'U'" size="normal" shape="circle" styleClass="comment-user-avatar" />
        </div>
        <div class="input-col">
          <textarea pTextarea formControlName="conteudo" placeholder="Escreva sua mensagem ou apoio..." rows="2"
            [autoResize]="true" class="comment-textarea" (keydown)="onEnterPress($event)"></textarea>
        </div>
      </div>

      <div class="floating-comment-footer">
        <span class="key-hint">Pressione <kbd>Enter</kbd> para enviar</span>
        <div class="footer-actions">
          <button type="button" class="btn-cancel" (click)="closeComment($event)">
            Cancelar
          </button>
          <button type="submit" class="btn-submit"
            [disabled]="isSubmitting || !formComment.get('conteudo')?.value?.trim()">
            <i class="pi pi-send" *ngIf="!isSubmitting"></i>
            <i class="pi pi-spin pi-spinner" *ngIf="isSubmitting"></i>
            <span>Comentar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>